import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UsersStateModel } from '@features/client/users/state/users-state.model';
import { ChangeUserFormState } from '@features/client/users/state/users.actions';

@State<UsersStateModel>({
  name: 'users',
  defaults: {
    userIsBeingEdited: false,
  },
})
@Injectable()
export class UsersState {
  @Action(ChangeUserFormState)
  public changeUserFormState(ctx: StateContext<UsersStateModel>, { userIsBeingEdited }: UsersStateModel): void {
    ctx.patchState({ userIsBeingEdited });
  }
}
